module.exports = __webpack_public_path__ + "img/graph_2.74a0c588.svg";